import * as patientActions from './reducer';
import reducer from './reducer';

export { patientActions };

export default reducer;
